import React, { useEffect } from 'react';
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { useNavigate } from 'react-router-dom';
import Header from '../../../Header/Header';
import Footer from '../../../Footer/Footer';
import { Typography, Grid, Box } from '@mui/material';
import mat78Image from '../../../assets/img/MAT_78.png';

const TrayectoriaMAT_78 = ({ }) => {

    const { trackPageView } = useMatomo();
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Suma y Sigue | Trayectoria de Especialización para la Enseñanza de la Matemática en 7° y 8° Básico";
        trackPageView();
    }, []);

    return (
        <Grid style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header current={"trayectorias"} />
            <Grid
                p={"0 20px"}
                component="div"
                sx={{
                    flexGrow: 1,
                    m: '30px auto',
                    maxWidth: '940px',
                    width: '100%',
                }}
            >
                <Typography variant='subtitle' fontWeight={"bold"} m={"20px 0"} textAlign={"center"}>
                    Trayectoria de Especialización para la Enseñanza de la Matemática en 7° y 8° Básico
                </Typography>
                <Typography variant='p' minHeight={"40px"}>
                    Esta trayectoria formativa está dirigida especialmente a
                    profesores que imparten procesos de enseñanza aprendizaje
                    en el segundo ciclo básico. Se enfoca en el desarrollo de
                    conocimientos especializados para enseñar contenidos
                    relacionados con la enseñanza de las relaciones
                    proporcionales y el estudio de los gráficos, además profundiza
                    en la geometría necesaria para 7º y 8º básico. Ambos temas,
                    son complejos de abordar en el aula por lo que requieren de
                    una especialización de los docentes.
                </Typography>
                <Typography variant='title-small' fontWeight={"bold"} mt={"20px"}>
                    Información general
                </Typography>
                <Typography variant='p' m={"20px 0"}>
                    <ul>
                        <li>
                            Dirigido a profesores/as de <b>7° a 8° básico</b>.
                        </li>
                        <li>
                            Enfocado en los ejes de <b>Geometría, Álgebra y Funciones</b>.
                        </li>
                        <li>
                            Cursos Suma y Sigue:
                        </li>
                        <li style={{ listStyleType: 'none' }}>
                            <ul>
                                <li>Analizando Relaciones Proporcionales y Gráficos</li>
                                <li>Geometría</li>
                                <li>Preparación de la Enseñanza y Evaluación de Aprendizajes de 2º ciclo</li>
                                <li>Fracciones, Razones y Porcentajes</li>
                            </ul>
                        </li>
                        <li>
                            Modalidad de evaluación y aprobación:
                        </li>
                        <li style={{ listStyleType: 'none' }}>
                            <ul>
                                <li>La evaluación de cada curso contempla:</li>
                                <li style={{ listStyleType: 'none' }}>
                                    <ul>
                                        <li>Desarrollo de los talleres virtuales (30%)</li>
                                        <li>Controles (60%)</li>
                                        <li>Preguntas calificadas (10%)</li>
                                    </ul>
                                </li>
                                <li>
                                    Para aprobar la trayectoria se deben aprobar cada
                                    uno de los cursos que la componen.
                                </li>
                            </ul>
                        </li>
                    </ul>
                </Typography>
                <Typography variant='title-small' fontWeight={"bold"} mt={"40px"}>
                    Objetivos
                </Typography>
                <Typography variant='p' m={"20px 0"}>
                    <b>Objetivo general:</b> Desarrollar competencias
                    matemáticas y didácticas para conducir y evaluar la
                    enseñanza de la matemática en 7° y 8° básico,
                    centrados en el desarrollo de habilidades
                    matemáticas.
                </Typography>
                <Typography variant='p' m={"20px 0"}>
                    <b>Objetivos específicos:</b>
                    <ul>
                        <li>
                            Fortalecer conocimientos disciplinares
                            especializados para la enseñanza de la
                            proporcionalidad, gráficos y geometría en 7° y
                            8° básico, atendiendo a la transición entre la
                            educación básica y media.
                        </li>
                        <li>
                            Desarrollar competencias didácticas para
                            preparar la enseñanza de la matemática en 7° y
                            8° básico, potenciando el desarrollo de
                            habilidades en los estudiantes.
                        </li>
                        <li>
                            Desarrollar competencias pedagógicas para
                            evaluar el aprendizaje de los estudiantes en
                            matemática en 7° y 8° básico, incorporando las
                            habilidades matemáticas.
                        </li>
                    </ul>
                </Typography>
                <Typography variant='title-small' fontWeight={"bold"} mt={"40px"}>
                    Descripción de la trayectoria
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Box
                        component="img"
                        sx={{
                            maxWidth: "100%",
                            maxHeight: "100%"
                        }}
                        alt="Suma y Sigue"
                        src={mat78Image}
                    />
                </Box>
                <Typography variant='p' fontWeight={"bold"} mt={"40px"}>
                    <span
                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                        onClick={() => navigate('/trayectorias')}
                    >
                        ← Ver más trayectorias
                    </span>
                </Typography>
            </Grid>
            <Footer />
        </Grid>
    );

};

export default TrayectoriaMAT_78;